module.exports = __webpack_public_path__ + "media/images/plans/ceremony/hall-list/plan-ceremony-lineup-kyushu-2-1138b7998f7c89cfaea8be1bab13ec99.png";